console.log('INF SCROLL');

function infiniteScrollCollection() {
    var endlessScroll = new Ajaxinate({
        container: "#collection .product-list",
        pagination: "#AjaxinatePagination",
        method: "scroll",
        loadingText: "",
        offset: 0,
        callback: onAjaxinateCallback,
    });
}

function onAjaxinateCallback() {
    updatePageInURL();
    animateNewProducts();
}

function animateNewProducts() {
    const productList = document.querySelector("#collection .product-list");
    console.log(productList, 'productList');
    if (!productList) return;

    const newItems = productList.querySelectorAll("product-card:not([data-loaded])");

    newItems.forEach((item, i) => {
        item.dataset.loaded = "true";
        item.style.opacity = "1";
        item.style.transform = "translateY(0px)";
        item.setAttribute("reveal-on-scroll", "false");
    });
}

let lastKnownPage = 1; // 🔑 rastrea la última página conocida

function updatePageInURL() {
    const paginationEl = document.querySelector("#AjaxinatePagination a");

    if (paginationEl) {
        // Hay más páginas: data-pagination apunta a la siguiente, restamos 1
        const loadedPage = parseInt(paginationEl.getAttribute("data-pagination"), 10) - 1;
        if (!loadedPage || loadedPage < 2) return;
        lastKnownPage = loadedPage;
        history.pushState({ page: loadedPage }, "", buildPageURL(loadedPage));
    } else {
        // Última página: no hay enlace, usamos lastKnownPage + 1
        const lastPage = lastKnownPage + 1;
        lastKnownPage = lastPage;
        history.pushState({ page: lastPage }, "", buildPageURL(lastPage));
    }
}

function buildPageURL(page) {
    const url = new URL(window.location.href);
    url.searchParams.set("page", page);
    return url.toString();
}

// ---------------------------------------------------------------------------

const selector = "#collection";
let cacheManager = {};

window.addEventListener("pageshow", function (e) {
    onLoad(e);
});

function onLoad(e) {
    cacheManager = new PageCacheManager({
        bodySelector: selector,
        onLoaded: onLoadedCache,
        onCached: onCachedCache,
    });

    if (!e.persisted) {
        document.addEventListener("click", function (e) {
            const closest = e.target.closest(".product-list product-card");
            if (closest) cacheManager.cachePage();
        });
    }
}

function onLoadedCache(e) {
    infiniteScrollCollection();
    markExistingProductsAsLoaded();
}

function markExistingProductsAsLoaded() {
    document.querySelectorAll("#collection .product-list product-card").forEach(item => {
        item.dataset.loaded = "true";
        item.style.opacity = "1 !important";
        item.style.transform = "translateY(0px) !important";
        item.setAttribute("reveal-on-scroll", "false");
    });
}

function onCachedCache(e) {
    console.log("cached");
}